import React from "react";
import {Route, Routes} from "react-router-dom";
import {AuthLayout} from "./AuthLayout";
import {Login} from "../pages/authentication/Login";
import {EmployeeNumber} from "../pages/authentication/onboard/EmployeeNumber";
import {OneTimePin} from "../pages/authentication/onboard/OneTimePin";
import {ValidateInfo} from "../pages/authentication/onboard/ValidateInfo";
import {CreatePassword} from "../pages/authentication/onboard/CreatePassword";
import {SuccessOnboard} from "../pages/authentication/onboard/SuccessOnboard";
import {VerifyEmail} from "../pages/authentication/onboard/VerifyEmail";
import {PinSetup} from "../pages/authentication/onboard/PinSetup";


export const UnAuthenticatedRoutes = () => {
    return (
        <AuthLayout>
            <Routes>
                {/* Define routes for authenticated users */}
                <Route path="/login" element={<Login />} />
                <Route path="/employee-number" element={<EmployeeNumber />} />
                <Route path="/one-time-password" element={<OneTimePin />} />
                <Route path="/validate-info" element={<ValidateInfo />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/create-password" element={<CreatePassword />} />
                <Route path="/pin-setup" element={<PinSetup />} />
                <Route path="/success" element={<SuccessOnboard />} />
            </Routes>
        </AuthLayout>
    )
}